module.exports = __webpack_public_path__ + "static/media/dropbox.44db08f0.svg";